export default function HVACServices() {
  const services = [
    {
      icon: 'ri-temp-cold-line',
      title: 'AC Installation & Replacement',
      description: 'Expert installation of energy-efficient air conditioning systems tailored to El Paso\'s hot climate.'
    },
    {
      icon: 'ri-fire-line',
      title: 'Heating System Services',
      description: 'Furnace installation, repair, and maintenance to keep your home warm during winter months.'
    },
    {
      icon: 'ri-tools-line',
      title: 'HVAC Repair & Maintenance',
      description: 'Fast, reliable repair services and preventive maintenance to extend your system\'s lifespan.'
    },
    {
      icon: 'ri-wind-line',
      title: 'Duct Cleaning & Sealing',
      description: 'Improve air quality and efficiency with professional duct cleaning and sealing services.'
    },
    {
      icon: 'ri-leaf-line',
      title: 'Energy Efficiency Upgrades',
      description: 'Upgrade to smart thermostats and high-efficiency systems to reduce energy costs.'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Emergency Service',
      description: 'Round-the-clock emergency HVAC services for urgent repairs and system failures.'
    }
  ];

  return (
    <section id="services" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Comprehensive HVAC Services in El Paso
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            From installation to emergency repairs, our network of HVAC contractors provides complete heating and cooling solutions for your home or business.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="bg-gradient-to-br from-orange-50 to-white p-8 rounded-xl border border-orange-100 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-orange-600 text-white rounded-lg mb-6">
                <i className={`${service.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
